import {
  HeroAjaxCreatePaxRequest,
  HeroApiBookingProduct,
  HeroApiCreateBookingRequest,
  HeroApiWindcaveSessionRequest,
  PersonBooking
} from './models';
import { CookieCollection, failedPayment, getUrlParameter, hideLoader, modalalert, removeLastSegmentFromUrl } from './script';
import * as log from 'loglevel';
// @ts-ignore
import * as Api from './api';
import * as _ from 'lodash';

/**
 * @returns {(PersonBooking|undefined)}
 */
export const processGiftFormIsValid = () => {
  console.log('validating...');
  const isInvalidClassName = 'is-invalid';

  // const $createBookingWrap = $('.createbookingwrap');
  const $firstName = $('#FirstName');
  const firstName = $firstName.val() as string | undefined;
  const $lastName = $('#LastName');
  const lastName = $lastName.val() as string | undefined;
  const $emailAddress = $('#EmailAddress');
  const emailAddress = $emailAddress.val() as string | undefined;
  const $phone = $('#PhoneNumber');
  const phone = $phone.val() as string | undefined;
  const $postcode = $('#Postcode');
  const postcode = $postcode.val() as string | undefined;
  const $giftFirstName = $('#RecipientFirstName');
  const giftFirstName = $giftFirstName.val() as string | undefined;
  const $giftLastName = $('#RecipientLastName');
  const giftLastName = $giftLastName.val() as string | undefined;
  const $giftEmailAddress = $('#RecipientEmail');
  var giftEmailAddress = $giftEmailAddress.val() as string | undefined;
  const $giftMessage = $('#Message');
  const giftMessage = $giftMessage.val() as string | undefined;
  const $giftValue = $('#GiftValue');
  const $customValue = $('#CustomValue');
  const customValue = $customValue.val() as number | undefined;
  const $giftValueSelect = $('select#GiftValue option:checked');
  const giftValue = $giftValueSelect.val() as number | undefined;
  const $sendTo = $('#SendTo');
  
  if ($sendTo.val() == 'me')
  {
    giftEmailAddress = emailAddress;
  }

  const terms = $('#terms').is(':checked');
  let error = false;

  // store values in cookie
  const personBooking: PersonBooking = {
    firstName: firstName || '',
    lastName: lastName || '',
    emailAddress: emailAddress || '',
    phoneNumber: phone || '',
    postcode: postcode || '',
    specialRequests: '',
    disabilityRequirements: '',
    giftFirstName: giftFirstName || '',
    giftLastName: giftLastName || '',
    giftEmailAddress: giftEmailAddress || '',
    giftMessage: giftMessage || '',
    giftValue: giftValue || 0,
    customValue: customValue || 0,
    terms: terms,
    newsletter: $('#newsletter').is(':checked'),

  };
  CookieCollection.PersonBooking.set(personBooking);

  if (!firstName || validator.isEmpty(firstName)) {
    $firstName.addClass(isInvalidClassName);
    error = true;
  } else {
    $firstName.removeClass(isInvalidClassName);
  }

  if (!lastName || validator.isEmpty(lastName)) {
    $lastName.addClass(isInvalidClassName);
    error = true;
  } else {
    $lastName.removeClass(isInvalidClassName);
  }

  if (!postcode || validator.isEmpty(postcode)) {
    $postcode.addClass(isInvalidClassName);
    error = true;
  } else {
    $postcode.removeClass(isInvalidClassName);
  }
  if (!emailAddress || !validator.isEmail(emailAddress)) {
    $emailAddress.addClass(isInvalidClassName);
    error = true;
  } else {
    $emailAddress.removeClass(isInvalidClassName);
  }

  if (!phone || validator.isEmpty(phone)) {
    $phone.addClass(isInvalidClassName);
    error = true;
  } else {
    $phone.removeClass(isInvalidClassName);
  }

  if (!giftFirstName || validator.isEmpty(giftFirstName)) {
    $giftFirstName.addClass(isInvalidClassName);
    error = true;
  } else {
    $giftFirstName.removeClass(isInvalidClassName);
  }

  if (!giftLastName || validator.isEmpty(giftLastName)) {
    $giftLastName.addClass(isInvalidClassName);
    error = true;
  } else {
    $giftLastName.removeClass(isInvalidClassName);
  }

  if ($sendTo.val() == 'recipient')
  {
    if (!giftEmailAddress || !validator.isEmail(giftEmailAddress)) {
      $giftEmailAddress.addClass(isInvalidClassName);
      error = true;
    } else {
      $giftEmailAddress.removeClass(isInvalidClassName);
    }
  }
  else
  {
    $giftEmailAddress.removeClass(isInvalidClassName);
  }

  if ($sendTo.val() == 0)
  {
    $sendTo.addClass(isInvalidClassName);
    error = true;
  }
  else
  {
    $sendTo.removeClass(isInvalidClassName);
  }

  if (giftValue == 0 || (giftValue == -1 && !customValue)) {
    $giftValue.addClass(isInvalidClassName);
    error = true;
  } else {
    $giftValue.removeClass(isInvalidClassName);
  }

  if (!terms) {
    $('#terms').addClass(isInvalidClassName);
    error = true;
  } else {
    $('#terms').removeClass(isInvalidClassName);
  }

  if (error) {
    $('#myValidator').removeClass('d-none');
    return undefined;
  } else {
    $('#myValidator').addClass('d-none');
    return personBooking;
  }
};

/**
 * @param {(Event | undefined)} e
 */
const processGiftValidate = (e) => {
  if (e) {
    e.preventDefault();
  }
  processGiftFormIsValid();
};

/**
 * @param {MouseEvent} e
 */
const processPaymentOnSendToHeroClick = (e) => {
  e.preventDefault();

  $('#FirstName').on('change', processGiftValidate);
  $('#LastName').on('change', processGiftValidate);
  $('#Postcode').on('change', processGiftValidate);
  $('#EmailAddress').on('change', processGiftValidate);
  $('#PhoneNumber').on('change', processGiftValidate);
  $('#RecipientFirstName').on('change', processGiftValidate);
  $('#RecipientLastName').on('change', processGiftValidate);
  $('#RecipientEmail').on('change', processGiftValidate);
  $('#terms').on('change', processGiftValidate);
  $('#SendTo').on('change', processGiftValidate);
  $('#GiftValue').on('change', checkGiftValue);
  $('#CustomValue').on('change', checkGiftValue);

  if (!processGiftFormIsValid()) {
     return;
  }
  if (!e.target) {
    log.error('e.target should not be null');
    return;
  }
  const $target = $(e.target);
  if ($target.hasClass('disabled')) {
    log.debug('continue button is disabled');
    return;
  }

  const setBooking = async () => {
    log.debug('setBooking');

    const personBooking = processGiftFormIsValid();
    if (!personBooking) {
      modalalert('Please complete all fields', 'error', false);
      return;
    }

    let errorOccurred = false;

    if (personBooking.giftValue == -1)
    {
      personBooking.giftValue = personBooking.customValue;
    }
    if ($('#SendTo').val() == 'me')
    {
      personBooking.giftEmailAddress = personBooking.emailAddress;
    }

    const bookingProduct: HeroApiBookingProduct = {
      productId: $('#ProductId').val(),
      rateCode: '',
      rrp: personBooking.giftValue,
      productRateCode: '',
      paxRoomId: [],
      paxId: [],
      voucherNotes: personBooking.giftMessage,
      agentReference: 'Sold to: ' + personBooking.emailAddress + ' (' + personBooking.firstName + ' ' + personBooking.lastName + ')'
    };

    // create pax
    const data: HeroAjaxCreatePaxRequest = {
      first: personBooking.giftFirstName,
      last: personBooking.giftLastName,
      email: personBooking.giftEmailAddress,
      mobile: personBooking.phoneNumber,
      age: 18,
      country: personBooking.country,
      postcode: personBooking.postcode
    };

    try {
      const response = await Api.createPax(data);
      const pID = response.data;
      if (!pID) {
        log.error('unable to create pax');
        errorOccurred = true;
        return;
      }
      bookingProduct.paxId.push(pID.id);

    } catch (error) {
      log.error(error);
      errorOccurred = true;
    }

    if (errorOccurred) {
      log.error('error occurred during creation of pax. abort');
      return;
    }

    const bookingProducts: HeroApiBookingProduct[] = [];
    bookingProducts.push(bookingProduct);

    const booking: HeroApiCreateBookingRequest = {
      bookingProducts: bookingProducts
    };

    const createBookingResponse = await Api.createBooking(booking);
    const newBooking = createBookingResponse.data;

    if (newBooking) {
      const validateBookingResponse = await Api.validateBooking(newBooking);
      const validate = validateBookingResponse.data;
      if (validate && validate.IsValid) {

        const $captchaToken = $('#Token');
        const captchaToken = $captchaToken.val() as string;
        const sessionRequest = new HeroApiWindcaveSessionRequest(newBooking.id, newBooking.payable.toFixed(2), removeLastSegmentFromUrl(window.location.href), captchaToken);
        const session = await Api.initWindcaveSession(sessionRequest)

        if (session.data.success) {
          CookieCollection.BookingDetails.remove();
          const bookingDetails = {
            id: newBooking.id,
            amount: newBooking.payable
          };

          CookieCollection.BookingDetails.set(bookingDetails);

          // redirect to HPP
          window.location.replace(session.data.sessionRef);

        } else {
          hideLoader();
          failedPayment('', false);
        }
      } else {
        $('h1').text('There was an error validating your booking');
        $('.formwrap').remove();
        $('.col-lg-6 p').text(
          'Please call our booking team on 02 9978 4791 and quote booking number ' +
          newBooking.id +
          ' to complete your booking.'
        );
        $('#loader').addClass('hide');
      }
    }
  };

  // show submit button
  $('.form-group-submit').show();

  $('#loader')
    .removeClass('hide')
    .show();

  setTimeout(setBooking, 200);
};

export function initProcessGift() {
  const personBooking = CookieCollection.PersonBooking.get();

  // populate fields with previously entered values
  if (personBooking) {
    $('#FirstName').val(personBooking.firstName || '');
    $('#LastName').val(personBooking.lastName || '');
    $('#EmailAddress').val(personBooking.emailAddress || '');
    $('#Postcode').val(personBooking.postcode || '');
    $('#PhoneNumber').val(personBooking.phoneNumber || '');
    $('#RecipientFirstName').val(personBooking.giftFirstName || '');
    $('#RecipientLastName').val(personBooking.giftLastName || '');
    $('#RecipientEmail').val(personBooking.giftEmailAddress || '');
    $('#Message').val(personBooking.giftMessage || '');
    $('#GiftValue').val(personBooking.giftValue || '');    
    $('#CustomValue').val(personBooking.customValue || '');    
    $('#newsletter').prop('checked', personBooking.newsletter || false);
    if (personBooking.giftValue == -1)
    {
      $('#otherAmount').show();
    }
  }

  // credit card process payment container
  $('#btn-booking-submit').on(
    'click',
    null,
    null,
    processPaymentOnSendToHeroClick
  );

  const error = getUrlParameter('error') as string | undefined;
  if (error && personBooking) {
    modalalert(error.replace(/\+/g, ' '), 'error', false);
  }
}

$(function () {
  // review booking page
  if ($('#processgift').length) {
    initProcessGift();
  }
});
